import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// import './assets/css/all.css'
import editorConf from './plugins/editorConf.js'
import request from './plugins/request.js'
import VueWechatTitle from 'vue-wechat-title'
import page from './components/page.vue'
import easySearch from './components/easySearch.vue'

//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
Vue.component('page', page)
Vue.component('easySearch', easySearch)
Vue.config.productionTip = false
Vue.use(editorConf)
Vue.use(VueWechatTitle)
Vue.prototype.$request = request
Vue.prototype.$editorConf = editorConf
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
